"use client";

import { c as _c } from "react/compiler-runtime";
import { useAccordionItem } from "@website/ui/accordion/accordion.hook";
import styles from "@website/ui/accordion/accordion.module.scss";
import { AccordionPropertiesType } from "@website/ui/accordion/accordion.types";
import { Button } from "@website/ui/button";
import { FC } from "react";
export const Accordion: FC<AccordionPropertiesType> = properties => {
  const $ = _c(30);
  const {
    buttonText,
    buttonProperties,
    detailsProperties,
    summeryProperties
  } = useAccordionItem(properties);
  const {
    content,
    disabled,
    title,
    subtitle,
    variant,
    scroll,
    StartIcon,
    titleClassname,
    contentWrapperClassname,
    noOverflowHidden,
    className
  } = properties;
  const t0 = `${styles.details} ${styles[variant || "outline"]} ${className}`;
  const t1 = `${styles.summery} ${disabled ? styles.disabled : ""}`;
  let t2;
  if ($[0] !== StartIcon) {
    t2 = StartIcon ? <div className={styles.icon}>{StartIcon}</div> : null;
    $[0] = StartIcon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${styles.title} ${titleClassname}`;
  let t4;
  if ($[2] !== t3 || $[3] !== title) {
    t4 = <h3 className={t3} itemProp="name">{title}</h3>;
    $[2] = t3;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== subtitle) {
    t5 = subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null;
    $[5] = subtitle;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className={styles["header-content"]}>{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== buttonProperties || $[11] !== buttonText) {
    t7 = <Button className={styles.button} {...buttonProperties}>{buttonText}</Button>;
    $[10] = buttonProperties;
    $[11] = buttonText;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== summeryProperties || $[14] !== t1 || $[15] !== t2 || $[16] !== t6 || $[17] !== t7) {
    t8 = <summary {...summeryProperties} className={t1}>{t2}{t6}{t7}</summary>;
    $[13] = summeryProperties;
    $[14] = t1;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `${styles["content-wrapper"]} ${contentWrapperClassname} ${noOverflowHidden ? styles["no-overflow"] : ""}`;
  const t10 = `${styles.content} ${scroll ? styles[scroll] : ""}`;
  let t11;
  if ($[19] !== content || $[20] !== t10) {
    t11 = <div className={t10} itemProp="text">{content}</div>;
    $[19] = content;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <div itemProp="acceptedAnswer" itemScope={true} itemType="https://schema.org/Answer" className={t9}>{t11}</div>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== detailsProperties || $[26] !== t0 || $[27] !== t12 || $[28] !== t8) {
    t13 = <details itemProp="mainEntity" itemScope={true} itemType="https://schema.org/Question" {...detailsProperties} className={t0}>{t8}{t12}</details>;
    $[25] = detailsProperties;
    $[26] = t0;
    $[27] = t12;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};